import React, { useEffect } from 'react';
import { Button, Modal} from 'react-bootstrap';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from '../../../../Auth';
import { useAxios } from '../../../../AxiosHandler';

function DeletePersonModal(props) {
    const auth = useAuth();
    const t = useTranslate();  
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const handleDeletePerson = () => {
        axios.delete(
            "/api/persons/" + props.personId,
            {},
            {
                headers: {'x-access-token': auth.user["token"]}
            }
        ).then(res => {
            if (props.onDeleted != undefined) props.onDeleted();
            notifySuccess(t("people.toast_people_deleted"));
        });
    }

    // async function fetchData() {
    //     if (props.personId != undefined) {
    //         axios.all([
    //             axios.single({
    //                 method: "get",
    //                 url: "/api/persons/",
    //                 responseType: "json",
    //                 headers: {'x-access-token': auth.user["token"]}
    //             })
    //         ])
    //         .then(axios.spread((...res) => {
    //             setEditPerson(res[0].data);
    //         }));
    //     }
    // }

    useEffect(() => {

    }, [props.show, props.personId]);

    return (
        <div>
            <Modal show={props.show} onHide={() => { if(props.onHide != undefined) props.onHide(); }}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("people.delete_person")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t("people.delete_info")}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => { if(props.onCancel != undefined) props.onCancel(); }}>
                        {t("people.cancel")}
                    </Button>
                    <Button onClick={handleDeletePerson}>
                        {t("people.delete_person")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
 
export default DeletePersonModal; 